import React from 'react';
import {reduxForm} from 'redux-form';
import {validateRequiredFields} from '../../utils/form';

import Button from '../button';
import FormField from '../form/form-field';
import Alert from '../alert';
import DateField from '../form/date-field';
import BaseForm from '../form/base-form';
import LocalizedStrings from '../../localization/strings';

const fields = [
    'id',
    'name',
    'isFree',
    'stageId',
    'code',
    'prices[].id',
    'prices[].price',
    'prices[].children_price',
    'prices[].older_price',
    'prices[].price_until_date',
    'order'
];

function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, ['name', 'code'], errors);
    errors.prices = values.prices.map(price => {
        return validateRequiredFields(price, [
            'price', 'price_until_date', 'older_price', 'children_price'
        ], {});
    });
    return errors;
}

class DistanceForm extends BaseForm {

    componentDidMount() {
        setTimeout(() => this.refs.name.focus());
    }

    render() {
        const {
            submitting,
            errors,
            error,
            handleSubmit,
            fields: {
                name,
                isFree,
                prices,
                code,
                order
            }
        } = this.props;

        return (
            <div className="distance-form">
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}
                    <FormField label={LocalizedStrings.title} name="name" field={name}>
                        <input ref="name" className="border-full larger" placeholder={LocalizedStrings.title} type="text" {...name}/>
                    </FormField>
                    <FormField label={LocalizedStrings.code} name="code" field={code} helperText={LocalizedStrings.codeHelperText}>
                        <input ref="code" className="border-full larger" placeholder={LocalizedStrings.code} type="text" {...code}/>
                    </FormField>
                    <FormField label={LocalizedStrings.order} name="order" field={order}>
                        <input ref="link" className="border-full larger" placeholder={LocalizedStrings.order} type="number" {...order}/>
                    </FormField>
                    <FormField label={LocalizedStrings.isFree} name="isFree" field={isFree}>
                        <input type="checkbox" {...isFree}/>
                    </FormField>
                    {prices.map((price, index) => <div key={index} className="inline-fields">
                        <FormField label={LocalizedStrings.price} name="price" field={price.price}>
                            <input ref="price" className="border-full larger" placeholder={LocalizedStrings.price} type="text" {...price.price}/>
                        </FormField>

                        <FormField label={LocalizedStrings.childrenPrice} name="children_price" field={price.price}>
                            <input ref="children_price" className="border-full larger" placeholder={LocalizedStrings.childrenPrice} type="text" {...price.children_price}/>
                        </FormField>
                        <FormField label={LocalizedStrings.olderPrice} name="older_price" field={price.price}>
                            <input ref="children_price" className="border-full larger" placeholder={LocalizedStrings.olderPrice} type="text" {...price.older_price}/>
                        </FormField>
                        <FormField label={LocalizedStrings.dateUntil} name="price_until_date" field={price.price_until_date}>
                            <DateField {...price.price_until_date}></DateField>
                        </FormField>
                        <a className="btn btn-red" onClick={() => {
                            prices.removeField(index);
                        }}>
                            {LocalizedStrings.remove}
                        </a>
                    </div>)}
                    <a className="btn m-top-10 m-bot-10" onClick={() => {
                        prices.addField();
                    }}><i/> {LocalizedStrings.addPrice}
                    </a>
                    <div className="button-group">

                        <Button loading={submitting} submit={true} disabled={submitting || Object.keys(errors).length} type="primary">
                            {LocalizedStrings.submit}</Button>
                        <Button disabled={submitting} onClick={e => {
                            e.preventDefault();
                            this.props.cancel();
                        }} type="empty-primary pull-right">
                            {LocalizedStrings.cancel}</Button>
                    </div>
                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'distance-form',
    fields,
    validate,
    destroyOnUnmount: true
}, state => ({initialValues: state.distance.distance}))(DistanceForm);



// WEBPACK FOOTER //
// ./src/js/components/stage/distance-form.js